export enum CellType {
  Custom,
  Text,
  Action,
  Checkbox,
  Empty,
  CollapseControl,
}
